import { render, staticRenderFns } from "./ReportBrand.vue?vue&type=template&id=590bd3b4&"
import script from "./ReportBrand.vue?vue&type=script&lang=js&"
export * from "./ReportBrand.vue?vue&type=script&lang=js&"
import style0 from "./ReportBrand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports